/* NØBASIC — regalo automático (lentes) en el carrito lateral.
   Lee el span [data-nb-gift-sync] que imprime snippets/nb-cyber-msg.liquid:
   - data-add: variante a agregar como regalo (se agrega con la propiedad _regalo).
   - data-rm: línea de regalo agregada sola que hay que sacar (bajó del mínimo o terminó la promo).
   Usa el mismo camino del carrito lateral (botones data-nb-qty de nobasic-pro.js) para re-renderizarlo.
   Si el cliente saca los lentes a mano, no se vuelven a agregar en esa sesión. */
(function () {
  'use strict';
  var busy = false, timer = null;
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function viaDrawer(key, qty) {
    var b = document.createElement('button');
    b.type = 'button';
    b.hidden = true;
    b.setAttribute('data-nb-qty', String(qty));
    b.setAttribute('data-key', key);
    b.setAttribute('data-nb-auto', '1');
    document.body.appendChild(b);
    b.click();
    b.remove();
  }

  function release() { setTimeout(function () { busy = false; schedule(); }, 1200); }

  function sync() {
    if (busy) return;
    var el = document.querySelector('[data-nb-drawer] [data-nb-gift-sync]');
    if (!el) return;
    var add = el.getAttribute('data-add'), rm = el.getAttribute('data-rm');

    if (rm) {
      busy = true;
      viaDrawer(rm, 0);
      release();
      return;
    }
    if (add && ssGet('nb-gift-no') !== '1' && ssGet('nb-gift-fail') !== add) {
      busy = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add), quantity: 1, properties: { _regalo: '1' } }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { ssSet('nb-gift-fail', add); return; }
          var it = res.j && res.j.items && res.j.items[0];
          if (it && it.key) viaDrawer(it.key, 1);
          if (window.NB && NB.toast) NB.toast('¡Sumamos los lentes de regalo!');
        })
        .catch(function () {})
        .then(release);
    }
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 60); }

  /* Si el cliente quita los lentes a mano, respetamos la decisión. */
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-nb-qty]');
    if (!q || q.hasAttribute('data-nb-auto') || q.getAttribute('data-nb-qty') !== '0') return;
    var el = document.querySelector('[data-nb-drawer] [data-nb-gift-sync]');
    var gk = el && el.getAttribute('data-gift-key');
    if (gk && q.getAttribute('data-key') === gk) ssSet('nb-gift-no', '1');
  }, true);

  function start() {
    var d = document.querySelector('[data-nb-drawer]');
    if (!d) return;
    new MutationObserver(schedule).observe(d, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
